<template>
    <!-- 应用模块 -->
    <div class="box_row_center">
        <div class="apply" v-for="(item, index) in applyList" :key="index" @click.stop="applayInfo(item)">
            <div class="title">{{ item.applyName }} <i class="iconfont iconbianjisekuai" @click.stop="editApply(item)"></i></div>
            <div class="applyId">
                <div class="id-title">应用ID:</div>
                <div>{{ item.applyId }}</div>
            </div>
            <div class="applyAlready">
                <img src="http://cdn.chinachdu.com/webStatic/pay-platform/qudao.png" alt="" />
                <div class="apply-num">
                    <div v-if="item.applyType === 'ZWBY'">
                        <div v-if="item.mchChanNumber>0">
                            <div>您已配置<span>{{ item.mchChanNumber }}</span>条支付渠道</div>
                            <div @click.stop="addPay(item)" class="apply-btn">继续配置</div>
                        </div>
                        <div v-else>
                            <div>尚未配置支付渠道</div>
                            <div @click.stop="addPay(item)" class="apply-btn">立即配置</div>
                        </div>
                    </div>
                    <div v-else>
                        <div>您已配置<span>汇付宝</span></div>
                    </div>
                </div>
            </div>
            <div class="bottom" @click.stop="lookApply(item)">查看应用配置<span class="iconfont iconxiangyou"></span></div>
        </div>
        <!-- 点击添加 -->
        <div class="box_column_center add" @click.stop="createApply">
            <i class="iconfont iconiconaddsuccess"></i>
            <span class="add-apply">添加应用</span>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    applyList: {
      type: Array,
    },
  },
  inject: {
    createApply: 'create',
    lookApply: 'look',
    addPay: 'add',
    editApply: 'edit',
    applayInfo: 'info',
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.box_row_center {
  display: flex;
  flex-wrap: wrap;
}
.apply {
  width: 290px;
  height: 300px;
  background: @bg-white;
  margin: 30px 10px 0;
  padding: 30px 25px 20px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.title {
  padding-left: 30px;
  font-size: 20px;
  i {
    font-size: 16px;
    color: #999;
    cursor: pointer;
  }
}
.applyId {
  display: flex;
  padding: 10px 0 40px;
  font-size: 12px;
  color: #999;
  word-wrap: break-word;
  word-break: break-all;
  .id-title {
    width: 48px !important;
  }
}
.applyAlready {
  display: flex;
  img {
    width: 50px;
    height: 50px;
    margin-right: 30px;
  }
  .apply-num {
    font-size: 14px;
    color: #999;
    height: 20px;
    line-height: 20px;
    div:first-child {
      span {
        color: #ff9f07;
        padding: 0 5px;
        font-size: 16px;
      }
    }
    .apply-btn {
      color: #4359b7;
    }
  }
}
.bottom {
  margin: 75px 0 0 140px;
  font-size: 14px;
  color: #4359b7;
  cursor: pointer;
  i {
    color: #4359b7;
    font-size: 14px;
  }
}
.add {
  margin: 60px 0 0 50px;
  cursor: pointer;
  i {
    padding: 24px;
    border: 2px dashed #999;
    font-weight: 1000;
    font-size: 24px;
    color: #4359b7;
  }
  .add-apply {
    font-size: 14px;
    color: #4359b7;
    padding-top: 10px;
  }
}
</style>
